/**
 * Transforms a camelCase or PascalCase string into a human-readable label.
 * Also warns if the key contains Cyrillic characters, which may indicate a mistake in naming.
 *
 * @param {string} key - The original key to be transformed.
 * @returns {string} A formatted label with spaces and capitalized first letter.
 *
 * @example
 * getDefaultColumnLabelCellHelpers("userName"); // "User Name"
 * getDefaultColumnLabelCellHelpers("UserAge");  // "User Age"
 */
const getDefaultColumnLabelCellHelpers = (key: string): string => {
	if (typeof key !== "string") return "";

	const hasCyrillic = /[а-яА-ЯёЁіїєґІЇЄҐ]/.test(key);

	if (hasCyrillic) {
		// eslint-disable-next-line no-console
		console.warn(
			`⚠️ Column key "${key}" contains Cyrillic characters. This may lead to issues in column handling.`,
		);
	}

	return key
		.replace(/([a-z])([A-Z])/g, "$1 $2") // insert space between camelCase
		.replace(/^./, (char) => char.toUpperCase()); // capitalize first letter
};

export default getDefaultColumnLabelCellHelpers;
